import React, { PropTypes } from 'react'
import cx from 'classnames'

import './Loader.scss'

/**
 * Loader component
 *
 * STYLING: Pass a 'className' prop to the component and use the following CSS classes to style it:
 *   - .Loader-svg : The SVG path. You can change the color with the "stroke" property.
 *   - .Loader-text : The legend of the component. You can change the color with the "color" property.
 *
 *   Example:
 *     JS:
 *     <Loader className="white" />
 *
 *     CSS:
 *     .white .Loader-svg {
 *       stroke: white;
 *     }
 *     .white .Loader-text {
 *       color: #FFF;
 *     }
 *
 */

const Loader = (props) => {
  const {
    text,
    className
  } = props

  const wrapperClass = cx({
    Loader: true,
    [className]: className
  })

  return (
    <div className={wrapperClass}>
      <div>
        <svg xmlns='http://www.w3.org/2000/svg' width='57' height='50' viewBox='0 0 186 162'>
          <path
            d='M122.1527 72.37422l-53.033-53.56334c-3.53555-3.53554-24.60433-13.5343-44.0174 4.24264-19.32108 17.6927-8.13174 39.59798-4.24265 44.0174l72.30167 74.59976 70.88745-74.423c4.24265-4.77296 11.33216-27.27548-5.83363-45.4316-16.45258-17.40178-42.60318-3.18198-46.3155.35355'
            className='Loader-svg' />
        </svg>
      </div>

      <div className='Loader-text'>
        {text}
      </div>
    </div>
  )
}
Loader.displayName = 'Loader'
Loader.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string
}
Loader.defaultProps = {
  text: 'Cargando...'
}

export default Loader



// WEBPACK FOOTER //
// ./src/screens/App/shared/components/Loader/Loader.js